/**
 * @define Ensures that the button states carry over across all other add to cart experiances
 * @version 07-21-2026
 */

// assets/klaviyo-bis-sync.js
(function () {
  var PREFIX = 'Klaviyo-bis-sync:';

  function log() {
    var args = Array.prototype.slice.call(arguments);
    console.log.apply(console, [PREFIX].concat(args));
  }

  function getKlaviyoButton() {
    var btn = document.querySelector('#klaviyo-bis-button-container button');
    log('getKlaviyoButton() ->', btn ? 'FOUND' : 'NOT FOUND', btn);
    return btn;
  }

  function getNativeSoldOutButtons() {
    var btns = Array.from(document.querySelectorAll('[data-native-pre-order-btn]'));
    log('getNativeSoldOutButtons() -> found', btns.length, 'button(s)', btns);
    return btns;
  }

  function sync(triggerSource) {
    log('sync() called, triggered by:', triggerSource || 'unknown');

    var klaviyoBtn = getKlaviyoButton();
    if (!klaviyoBtn) {
      log('No Klaviyo button present. Doing nothing.');
      return false;
    }

    var nativeButtons = getNativeSoldOutButtons();
    if (nativeButtons.length === 0) {
      log('WARNING: Klaviyo button exists but zero native buttons found.');
      return true;
    }

    nativeButtons.forEach(function (btn, i) {
      log('Processing native button #' + i, btn);

      if (btn.disabled) {
        btn.disabled = false;
        log('  -> disabled removed');
      }
      if (btn.getAttribute('style')) {
        btn.removeAttribute('style');
        log('  -> inline style removed');
      }

      var content = btn.querySelector('button-content');
      var target = content || btn;
      if (target.textContent.trim() !== 'Notify me') {
        target.textContent = 'Notify me';
        if (content) content.setAttribute('up-text', 'Notify me');
        log('  -> text updated to Notify me');
      } else {
        log('  -> text already correct, skipped write');
      }

      if (!btn.dataset.bisBound) {
        btn.addEventListener('click', function (e) {
          log('Native button clicked.');
          var liveKlaviyoBtn = getKlaviyoButton();
          if (!liveKlaviyoBtn) {
            log('  -> no live Klaviyo button, allowing native behavior');
            return;
          }
          e.preventDefault();
          e.stopImmediatePropagation();
          liveKlaviyoBtn.click();
          log('  -> forwarded click to Klaviyo button');
        });
        btn.dataset.bisBound = 'true';
        log('  -> click listener bound');
      }
    });

    log('sync() complete.');
    return true;
  }

  var activePollTimer = null;

  function startPoll(triggerSource) {
    log('startPoll() called from:', triggerSource);

    if (activePollTimer) {
      clearInterval(activePollTimer);
      log('  -> cleared previous poll timer');
    }

    var count = 0;
    activePollTimer = setInterval(function () {
      count++;
      log('Poll attempt #' + count, '(source:', triggerSource + ')');
      sync('poll-' + count + '-' + triggerSource);

      if (count >= 10) {
        clearInterval(activePollTimer);
        activePollTimer = null;
        log('Polling stopped after 10 attempts for trigger:', triggerSource);
      }
    }, 500);
  }

  log('Script loaded. Event-driven + restartable polling.');

  document.addEventListener('DOMContentLoaded', function () {
    log('DOMContentLoaded fired.');
    sync('DOMContentLoaded');
    startPoll('DOMContentLoaded');
  });

  document.addEventListener('productrerender', function () {
    log('productrerender event fired.');
    sync('productrerender');
    startPoll('productrerender');
  });

  document.addEventListener('variant:change', function () {
    log('variant:change event fired.');
    sync('variant:change');
    startPoll('variant:change');
  });
})();